// Set data object type
import ibsu from "assets/images/objects/bsu.jpg";
import vBsu from "assets/images/objects/v_bsu.jpg";
import console from "assets/images/objects/console.jpg";
import trocar from "assets/images/objects/trocar.png";
import Stack from "assets/images/objects/Stack.png";
import Trolley from "assets/images/objects/trolley.jpg";
import Surgeon from "assets/images/objects/surgeon.jpg";
import Slave from "assets/images/objects/slave.jpg";
import Anesthesia from "assets/images/objects/anesthesia.jpg";

export enum BsuObjectId {
    IBsu = "i_bsu",
    VBsu = "v_bsu",
    Trocar = "trocar",
    Trocar10 = "trocar10",
    Console = "console",
    Stack = "stack",
    Trolley = "trolley",
    Surgeon = "surgeon",
    Slave = "slave",
    Anesthesia = "anesthesia",
}

export interface CMRItem {
    name: string;
    id: BsuObjectId;
    url: string;
    color: string | null;
    height: number;
}

const newObjectData: CMRItem[] = [
    {
        name: "I-BSU",
        id: BsuObjectId.IBsu,
        url: ibsu,
        color: null,
        height: 0,
    },

    {
        name: "V-BSU",
        id: BsuObjectId.VBsu,
        url: vBsu,
        color: null,
        height: 0,
    },

    {
        name: "trocar",
        id: BsuObjectId.Trocar,
        url: trocar,
        color: null,
        height: 0,
    },

    {
        name: "Surgeon Console",
        id: BsuObjectId.Console,
        url: console,
        color: null,
        height: 0,
    },

    {
        name: "Slave Stack",
        id: BsuObjectId.Slave,
        url: Slave,
        color: null,
        height: 0,
    },

    {
        name: "Stack",
        id: BsuObjectId.Stack,
        url: Stack,
        color: null,
        height: 0,
    },
    {
        name: "Hospital Trolley",
        id: BsuObjectId.Trolley,
        url: Trolley,
        color: null,
        height: 0,
    },
    {
        name: "Surgeon",
        id: BsuObjectId.Surgeon,
        url: Surgeon,
        color: null,
        height: 0,
    },
    {
        name: "Anesthesia Machine",
        id: BsuObjectId.Anesthesia,
        url: Anesthesia,
        color: null,
        height: 0,
    },
];
export const CmrMaxRoomWidth = 12;
export const CmrMinRoomWidth = 4;
export const CmrMaxRoomHeight = 12;
export const CmrMinRoomHeight = 4;

export default newObjectData;
